// @flow
import React, { type Element } from 'react';
import { find } from 'lodash';
import { DropdownButton, MenuItem } from 'angieslist-react-components';
import { Track } from 'angieslist-app-platform';
import './sortingOptions.scss';

type Props = {
  onSelect: (value: string[]) => any,
  categoryId: number,
  serviceProviderId: string,
  sortType: string,
  sortDirection: string,
};

const options = [
  { label: 'Most Recent', value: 'recency;desc' },
  { label: '5-1 Ratings', value: 'starRating;desc' },
  { label: '1-5 Ratings', value: 'starRating;asc' },
  { label: 'Cost (high to low)', value: 'cost;desc' },
  { label: 'Cost (low to high)', value: 'cost;asc' },
];

export const SortingOptionsComponent = ({
  sortType,
  sortDirection,
  categoryId,
  serviceProviderId,
  onSelect,
}: Props): Element<"div"> => {
  const selectedValue = `${sortType};${sortDirection}`;
  const currentOption = find(options, { value: selectedValue }) || options[0];
  return (
    <div style={{ marginTop: 20 }} className="clearfix">
      <label
        className="reviewlist-header_sortby-container"
        style={{ float: 'right' }}
        htmlFor="SortingOptionsDropdown"
      >
        Sort by &nbsp;
        <DropdownButton
          className="btn-tertiary"
          bsSize="small"
          title={currentOption.label}
          id="SortingOptionsDropdown"
          bsStyle="default-office"
          pullRight
          style={{ minWidth: 0 }}
        >
          {options.map((option) => {
            const key = option.value;
            return (
              <MenuItem
                role="button"
                key={key}
                eventKey={key}
                onSelect={value => onSelect(value.split(';'))}
              >
                <Track>
                  <div
                    id={`reviews-tab-sorting-option-${key}`}
                    data-track-categoryid-id={categoryId}
                    data-track-spid={serviceProviderId}
                    data-track-sort-by={key.split(';')[0]}
                    data-track-sort-direction={key.split(';')[1]}
                    data-track-page-index={0}
                  >
                    {option.label}
                  </div>
                </Track>
              </MenuItem>
            );
          })}
        </DropdownButton>
      </label>
    </div>);
};

export default SortingOptionsComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/SortingOptions.js